export default __webpack_public_path__ + "static/media/NotoSerifTamil.f0bc726b.ttf";